import { useAtom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

export type ColorScheme = 'light' | 'dark';

const getDefaultColorScheme = (): ColorScheme => {
  // Check localStorage for a saved color scheme
  const savedScheme = localStorage.getItem('colorScheme') as ColorScheme | null;

  if (savedScheme === 'light' || savedScheme === 'dark') {
    return savedScheme;
  }

  const darkModeQuery = window.matchMedia('(prefers-color-scheme: dark)');

  return darkModeQuery.matches ? 'dark' : 'light';
};

const colorSchemeAtom = atomWithStorage<ColorScheme>(
  'colorScheme',
  getDefaultColorScheme(),
);

export const useColorScheme = () => {
  const [colorScheme, setColorScheme] = useAtom(colorSchemeAtom);
  const toggleColorScheme = () => {
    setColorScheme((prev) => (prev === 'light' ? 'dark' : 'light'));
  };

  return {
    colorScheme,
    toggleColorScheme,
  };
};
